<div class="p-xxl mt-xl">
    <h2 class="text-center">Brak dostępu</h2>
</div>

